<!-- HTML -->
<template>
  <div>

    <!-- Music Section -->
    <MusicAudio />
    <!-- Footer Section -->
    <HomeFooter />

  </div>
</template>

<!-- JavaScript -->
<script>
// @ is an alias to /src
import MusicAudio from "@/components/music/MusicAudio.vue";
import HomeFooter from "@/components/home/HomeFooter.vue";

export default {

  name: "Home",

  components: {

    MusicAudio,
    HomeFooter

  }

};

</script>

<!-- CSS -->
<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
@import "../assets/scss/transitions.scss";

</style>
